<div class="card justify-content-center w-100 border-0" [ngStyle]="{'background-color': color}">
    <div class="row  center-form">
        <div class="col-md-6 col-sm-6">
            <mat-form-field class="full-width custom-form-field" appearance="fill" style="width: 100%">
                <mat-label>{{'languages.convention.conventionName' | translate}}</mat-label>
                <input type="text" matInput [(ngModel)]="conventionData.nom" name="nom" required (change)="emitForm()" class="custom-input"
                    [readonly]="!readOnlyAscConvention || disabledName ==false ||conventionData.status == ConventionStatusActive ||conventionData.status == ConventionStatusFerme" />
            </mat-form-field>
        </div>
        <div class="col-md-6 col-sm-6">
            <mat-spinner class="mt-4" *ngIf="!loaderOrganisme" [diameter]="20"></mat-spinner>
            <mat-form-field *ngIf="loaderOrganisme" class="full-width custom-form-field" appearance="fill">
                <mat-label> {{'languages.convention.Distributeur' | translate}}</mat-label>
                <input type="text" required matInput  [formControl]="organismeFromCtrl"
                 [matAutocomplete]="auto"
                    [readonly]="!readOnlyAscConvention || conventionData.status == ConventionStatusActive ||conventionData.status == ConventionStatusFerme"
                    (input)="onInputChanged()">
                <mat-autocomplete (optionSelected)="selectedOrganisme($event)" autoActiveFirstOption
                    [displayWith]="displayOrgFn" #auto="matAutocomplete">
                    <mat-option *ngFor="let option of filteredOrganisme | async" [value]="option">
                        {{option.nom}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>
        </div>
        <div class="col-md-6 col-sm-6">
            <mat-form-field appearance="fill" class="w-100 custom-form-field">
                <mat-label>{{'languages.convention.DateDeb' | translate}}</mat-label>
                <input matInput [matDatepicker]="debut" [(ngModel)]="conventionData.start_date" placeholder="{{'languages.convention.DateDeb' | translate}}"
                    required #date="ngModel" readonly  name="date"
                     (dateChange)="emitForm()" >
                <mat-datepicker-toggle matSuffix [for]="debut" [disabled]="!readOnlyAscConvention || conventionData.status == ConventionStatusActive ||conventionData.status == ConventionStatusFerme"></mat-datepicker-toggle>
                <mat-datepicker #debut>
                </mat-datepicker>
            </mat-form-field>
        </div>

        <div class="col-md-6 col-sm-6">
            <mat-form-field appearance="fill" class="w-100 custom-form-field">
                <mat-label>{{'languages.convention.DateFin' | translate}}</mat-label>
                <input matInput [matDatepicker]="fin" (dateChange)="emitForm()" [(ngModel)]="conventionData.valid_unitl"
                    placeholder="{{'languages.convention.DateFin' | translate}}" required #date="ngModel" readonly  name="date">
                <mat-datepicker-toggle matSuffix [for]="fin"  [disabled]="!readOnlyAscConvention ||conventionData.status ==ConventionStatusActive ||conventionData.status == ConventionStatusFerme"></mat-datepicker-toggle>
                <mat-datepicker #fin>
                </mat-datepicker>
            </mat-form-field>
        </div>
        <div class="col-md-6 col-sm-6">
            <mat-form-field appearance="fill" class="w-100 custom-form-field">
                <mat-label>{{'languages.convention.Gammes' | translate}}</mat-label>
                <mat-chip-list #Gammes>
                    <mat-chip *ngFor="let gammes of ListGammes" [selectable]="selectableGamme"
                        [removable]="removableGamme" (removed)="removeGammes(gammes)"
                        [disabled]="!readOnlyAscConvention || conventionData.status == ConventionStatusActive ||conventionData.status == ConventionStatusFerme">
                        {{gammes}}
                        <i matChipRemove *ngIf="removableGamme" class="fa fa-times" aria-hidden="true"></i>
                    </mat-chip>
                    <input placeholder="Selectionner Gammes..." #gammeInput
                        [readonly]="!readOnlyAscConvention || conventionData.status == ConventionStatusActive ||conventionData.status == ConventionStatusFerme" [formControl]="gammeFromCtrl"
                        [matAutocomplete]="autoGamme" [matChipInputFor]="Gammes"
                        [matChipInputSeparatorKeyCodes]="separatorKeysCodes" required>
                </mat-chip-list>
                <mat-autocomplete #autoGamme="matAutocomplete" (optionSelected)="selectedGammes($event)">
                    <mat-option *ngFor="let gammes of filteredGammes | async" [value]="gammes">
                        {{gammes.nom}}
                    </mat-option>
                </mat-autocomplete>
            </mat-form-field>

        </div>


        <div class="col-6  mt-5 justify-content-center" *ngIf="mode !== 'ajout'">
            <button type="button" (click)="OnOpen()" [disabled]=" !readOnlyAscConvention || conventionData.status == ConventionStatusFerme || conventionData.id ==''"
            class="changeStatus "
                [ngStyle]="{'opacity': !readOnlyAscConvention || conventionData.status == ConventionStatusFerme || conventionData.id =='' ?'0.5':'1'}">
                <span class="mb-1">{{'languages.convention.editStatus' | translate}}</span>
                <i class="fa-solid fa-arrow-right fa-icon-style   ml-3 fa-lg"></i>
              
            </button>
        </div>
    </div>
</div>
